import type { UserProfile } from '@/models/TableMaintenanceViewModels';

/** Format as "Last, First" (falls back to userId). */
export function displayUser(user: UserProfile): string {
  if (user.firstName || user.lastName) {
    const parts = [user.lastName, user.firstName]
      .map(part => (part ?? '').trim())
      .filter(part => part.length > 0);
    const name = parts.join(', ');
    return name || user.userId;
  }
  return user.userId;
}

/** Format as "Last, First (userId)" (falls back to userId). */
export function displayUserWithId(user: UserProfile): string {
  if (user.firstName || user.lastName) {
    const parts = [user.lastName, user.firstName]
      .map(part => (part ?? '').trim())
      .filter(part => part.length > 0);
    const name = parts.join(', ');
    return name ? `${name} (${user.userId})` : user.userId;
  }
  return user.userId;
}
